<!-- §1: contenedor fijo abajo a la izquierda. `pointer-events: none` lo hace
     transparente al mouse; sólo las tarjetas reciben clics.
     §5: región con aria-live para que el lector de pantalla anuncie lo nuevo. -->
<div
  class="notify"
  [class.notify--reduced]="reducedMotion"
  role="region"
  aria-live="polite"
  aria-atomic="false"
  aria-label="Notificaciones"
>
  <div
    class="note"
    *ngFor="let item of items(); trackBy: trackById"
    [class.note--saliendo]="item.saliendo"
    [attr.role]="roleFor(item)"
    (mouseenter)="onEnter(item)"
    (mouseleave)="onLeave(item)"
  >
    <!-- §2.1: el color vive sólo en este cuadro y en la barra de progreso. -->
    <span class="note__icon" [ngClass]="'note__icon--' + item.tipo" aria-hidden="true">
      <ng-container [ngSwitch]="item.tipo">
        <svg *ngSwitchCase="'ok'" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
        <svg *ngSwitchCase="'error'" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
        <svg *ngSwitchCase="'warn'" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <svg *ngSwitchCase="'info'" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="11" x2="12" y2="16" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <!-- §3: en curso el ícono es un spinner gris y no hay barra ni cierre automático. -->
        <span *ngSwitchCase="'cargando'" class="note__spinner"></span>
      </ng-container>
    </span>

    <div class="note__body">
      <p class="note__title">{{ item.titulo }}</p>
      <p class="note__desc" *ngIf="item.desc">{{ item.desc }}</p>
      <button
        *ngIf="item.accion"
        type="button"
        class="note__action"
        (click)="onAction(item)"
      >
        {{ item.accion.label }}
      </button>
    </div>

    <button
      type="button"
      class="note__close"
      aria-label="Cerrar notificación"
      (click)="onClose(item)"
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>

    <!-- §2.4: 3px pegada al borde inferior, se consume de izquierda a derecha. -->
    <span
      class="note__progress"
      *ngIf="muestraProgreso(item)"
      [ngClass]="'note__progress--' + item.tipo"
      [style.width.%]="progresoDe(item)"
      aria-hidden="true"
    ></span>
  </div>
</div>
